import DataTable from "@eisinc/MobiusOverrides/DataTable/DataTable";

export default DataTable;

export * from "@eisinc/MobiusOverrides/DataTable/DataTable";
